import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import AudienceAccessTypes from 'ContentUtils/constants/AudienceAccessTypes';
// Note: Can abandon visibilityOptions and its mappings once we migrate to KB v3
// and are only using memberships platform publicAccessRule enms and types
export const visibilityOptions = {
  PUBLIC: 'public',
  NOT_PUBLIC: 'not-public',
  RESTRICTED: 'restricted',
  ALL_AUDIENCE: 'not-defined',
  SSO: 'sso',
  SSO_WITH_SPECIFIC_CONTACTS: 'ssoWithSpecificContacts',
  ACCESS_GROUP_MEMBERSHIP: 'accessGroupMembership',
  SSO_WITH_ACCESS_GROUPS: 'ssoWithAccessGroups'
};
export const visibilityToRuleType = {
  [visibilityOptions.RESTRICTED]: PublicAccessRuleTypes.LIST_MEMBERSHIP,
  [visibilityOptions.SSO]: PublicAccessRuleTypes.SSO_LOGIN,
  [visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS]: PublicAccessRuleTypes.LIST_MEMBERSHIP,
  [visibilityOptions.PUBLIC]: PublicAccessRuleTypes.PUBLIC,
  [visibilityOptions.ACCESS_GROUP_MEMBERSHIP]: PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP,
  [visibilityOptions.SSO_WITH_ACCESS_GROUPS]: PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP
};
export const visibilityToAudienceAccessType = {
  [visibilityOptions.PUBLIC]: AudienceAccessTypes.ALL,
  [visibilityOptions.RESTRICTED]: AudienceAccessTypes.SPECIFIC_CONTACTS,
  [visibilityOptions.SSO]: AudienceAccessTypes.SSO,
  [visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS]: AudienceAccessTypes.SSO_WITH_SPECIFIC_CONTACTS,
  [visibilityOptions.ACCESS_GROUP_MEMBERSHIP]: AudienceAccessTypes.ACCESS_GROUP_MEMBERSHIP,
  [visibilityOptions.SSO_WITH_ACCESS_GROUPS]: AudienceAccessTypes.SSO_WITH_ACCESS_GROUPS
};
export const ruleTypeToVisibility = {
  [PublicAccessRuleTypes.SSO_LOGIN]: visibilityOptions.SSO,
  [PublicAccessRuleTypes.MEMBERSHIP_LOGIN]: visibilityOptions.RESTRICTED,
  [PublicAccessRuleTypes.SSO_WITH_LIST_MEMBERSHIP]: visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS,
  [PublicAccessRuleTypes.LIST_MEMBERSHIP]: visibilityOptions.RESTRICTED,
  [PublicAccessRuleTypes.PUBLIC]: visibilityOptions.PUBLIC,
  [PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP]: visibilityOptions.ACCESS_GROUP_MEMBERSHIP
};
export const restrictedVisibilities = [visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS, visibilityOptions.RESTRICTED, visibilityOptions.SSO, visibilityOptions.ACCESS_GROUP_MEMBERSHIP, visibilityOptions.SSO_WITH_ACCESS_GROUPS];

// Source of truth is content4j PublicAccessRuleType.java enum
// https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/PublicAccessRuleType.java
// Delete this once migrated over to KB v3
export const publicAccessRuleTypeOrdinals = {
  [PublicAccessRuleTypes.LIST_MEMBERSHIP]: 2,
  [PublicAccessRuleTypes.SSO_LOGIN]: 3,
  [PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP]: 7
};